import { render } from "./AssignInstance.vue?vue&type=template&id=25bb7085&scoped=true"
import script from "./AssignInstance.vue?vue&type=script&lang=js"
export * from "./AssignInstance.vue?vue&type=script&lang=js"

import "./AssignInstance.vue?vue&type=style&index=0&id=25bb7085&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25bb7085"]])

export default __exports__